class AssinarDocumentoAnuenciaOutputData {
	id
	idDocumentoAdesao
	isAssinado
	url
	idExternoAssinatura
	tipoRegistroDocumento
	situacaoDocumento

	constructor(data = {}) {
		this.id = data.id ?? null
		this.idDocumentoAdesao = data.idDocumentoAdesao ?? null
		this.url = data.url ?? null
		this.isAssinado = data.isAssinado ?? null
		this.idExternoAssinatura = data.idExternoAssinatura ?? null
		this.tipoRegistroDocumento = data.tipoRegistroDocumento ?? null
		this.situacaoDocumento = data.situacaoDocumento ?? null
	}
}
export default AssinarDocumentoAnuenciaOutputData
